<template>
  <app-page labelledby="page-title">
    <page-header
      title="Новое рабочее место"
      description="Задайте место в структуре и минимально необходимые права доступа."
    />

    <app-state v-if="state !== 'ready'" :state="state" :title="stateTitle" :message="stateMessage" @retry="requestData" />
    <form v-else class="role-form" @submit.prevent="addRole">
      <page-section title="Положение в структуре" description="Руководитель определяет место рабочего места в иерархии.">
        <div class="role-form__fields">
          <q-select
            v-model="parent"
            :options="parents"
            label="Руководитель"
            option-label="label"
            :rules="[(value) => !!value || 'Выберите руководителя']"
          />
          <q-input
            v-model.trim="roleTitle"
            label="Название рабочего места"
            maxlength="120"
            :rules="[(value) => !!value || 'Введите название рабочего места']"
          />
        </div>
      </page-section>

      <page-section title="Права доступа" description="Редактирование автоматически включает соответствующее право просмотра.">
        <role-permissions-editor v-model="permissions" test-id-prefix="new-role" />
      </page-section>

      <div class="role-form__actions">
        <q-btn flat no-caps label="Отмена" :to="{ name: 'org_main' }" />
        <q-btn color="primary" no-caps type="submit" label="Сохранить" :loading="saving" :disable="!canSubmit" />
      </div>
    </form>
  </app-page>
</template>

<script>
import AppPage from '../../../components/ui/AppPage.vue'
import AppState from '../../../components/ui/AppState.vue'
import PageHeader from '../../../components/ui/PageHeader.vue'
import PageSection from '../../../components/ui/PageSection.vue'
import RolePermissionsEditor, { normalizeRolePermissions } from '../../../components/org/RolePermissionsEditor.vue'

export default {
  name: 'NewRole',
  components: { AppPage, AppState, PageHeader, PageSection, RolePermissionsEditor },
  data() {
    return {
      state: 'loading',
      stateTitle: '',
      stateMessage: '',
      parents: [],
      parent: null,
      roleTitle: '',
      permissions: normalizeRolePermissions(),
      saving: false
    }
  },
  computed: {
    canSubmit() { return !!this.parent && !!this.roleTitle && !this.saving }
  },
  created() {
    this.onStructure = (response) => {
      if (response.error) {
        this.state = 'error'
        this.stateTitle = 'Не удалось загрузить структуру'
        this.stateMessage = 'Повторите запрос или вернитесь к структуре организации.'
        return
      }
      this.parents = (response.roles || []).map((item) => ({ label: item.label, id: item.id }))
      this.parent = this.parents[0] || null
      this.state = this.parents.length ? 'ready' : 'empty'
      if (!this.parents.length) {
        this.stateTitle = 'Нет доступного руководителя'
        this.stateMessage = 'Сначала должно существовать хотя бы одно рабочее место в структуре.'
      }
    }
    this.onCreated = (response) => {
      this.saving = false
      if (response.error || !response.role_id) {
        this.$q.notify({ color: 'negative', message: 'Не удалось создать рабочее место' })
        return
      }
      this.$q.notify({ color: 'positive', message: 'Рабочее место создано' })
      this.$router.push({ name: 'org_role_settings', params: { id: response.role_id } })
    }
    this.emitter.on('didReceiveOrgStructureFlat', this.onStructure)
    this.emitter.on('didCreateNewRole', this.onCreated)
    if (this.connection.isAuthenticated) this.requestData()
    else this.emitter.on('connectionReady', this.requestData)
  },
  beforeUnmount() {
    this.emitter.off('didReceiveOrgStructureFlat', this.onStructure)
    this.emitter.off('didCreateNewRole', this.onCreated)
    this.emitter.off('connectionReady', this.requestData)
  },
  methods: {
    requestData() {
      this.state = 'loading'
      this.connection.getOrgStructureFlat(this.connection.makeRequestId('role-parents'))
    },
    addRole() {
      if (!this.canSubmit) return
      this.saving = true
      this.connection.createNewRole(this.connection.makeRequestId('role-create'), {
        role_title: this.roleTitle,
        parent_role_id: this.parent.id,
        ...normalizeRolePermissions(this.permissions)
      })
    }
  }
}
</script>

<style scoped>
.role-form__fields { display: grid; max-width: 52rem; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: var(--sid-space-4); }
.role-form__actions { display: flex; justify-content: flex-end; gap: var(--sid-space-2); margin-top: var(--sid-space-6); }
@media (max-width: 599px) {
  .role-form__fields { grid-template-columns: 1fr; }
  .role-form__actions { align-items: stretch; flex-direction: column-reverse; }
  .role-form__actions :deep(.q-btn) { min-height: var(--sid-touch-target); }
}
</style>
